import React from 'react';
import { connect } from 'react-redux';

import { toggleGoogleInviteModal } from 'actions/google';
import { toggleSlackInviteModal } from 'actions/slack';
import {
  INVITE_MODAL_SOURCE_VIEWER_LIST_PANE,
  VIDEO_VIEW_INVITE_WIDGET_VIEWED,
} from 'constants/events';
import * as analytics from 'utilities/analytics';
import { getCloudfrontURI } from 'utilities/avatar';

import * as oAuthKeys from '../../../../shared/constants/oAuthKeys';
import FeatureFlaggedComponent from '../feature-flag-wrapper';
import { GROW_ENGAGE_REMOVE_VIEWER_INFO_BARRIER } from '../../../../shared/constants/featureFlag';

import './styles.less';

const ViewerList = class extends React.PureComponent {
  state = {
    fadeLeft: 0,
  };

  render() {
    const {
      hasNamedVideoViews,
      views,
      trimMode,
      inviteProvider = null,
    } = this.props;

    if (!views) {
      return null;
    }

    if (trimMode) {
      if (views.total === 0) {
        return <div className="viewer-list" />;
      }

      return <div className="viewer-list views" />;
    }

    let lockedDiv = null;

    if (!hasNamedVideoViews) {
      const clickHandler = event => {
        event.preventDefault();

        inviteProvider === oAuthKeys.GOOGLE
          ? this.props.toggleGoogleInviteModal()
          : this.props.toggleSlackInviteModal();
      };

      analytics.track(VIDEO_VIEW_INVITE_WIDGET_VIEWED, {
        source: INVITE_MODAL_SOURCE_VIEWER_LIST_PANE,
        provider: inviteProvider,
      });

      lockedDiv = (
        <a href="#" className="viewer-list-locked" onClick={clickHandler}>
          Find out who viewed your video
        </a>
      );
    }

    const namedViews = (views.named || []).map(view => {
      if (view.avatar) {
        return view;
      }

      const firstName = view.firstName || '';
      const lastName = view.lastName || '';

      return {
        firstName,
        lastName,
        picText: firstName.charAt(0) + lastName.charAt(0),
        avatarClass: 'no-pic',
      };
    });

    // make an Anonymous avatar for non-named viewers
    if (views.distinct > namedViews.length) {
      namedViews.push({
        firstName: 'Anonymous',
        picText: '+' + (views.distinct - namedViews.length),
        avatarClass: 'anon',
      });
    }

    const viewers = (
      <div className="viewers-outer">
        <div className="viewers" ref={this.viewersRef}>
          {namedViews.map((viewer, index) => (
            <div className="viewer" key={index}>
              {viewer.avatar && (
                <img className="avatar" src={getCloudfrontURI(viewer.avatar)} />
              )}
              {!viewer.avatar && (
                <div className={`avatar ${viewer.avatarClass}`}>
                  {viewer.picText}
                </div>
              )}
              <span className="viewer-name">{viewer.firstName}</span>
            </div>
          ))}
          <div className="viewer viewer-empty" />
        </div>
        <div className="viewers-fade" />
      </div>
    );

    return (
      <div className="viewer-list">
        <div className="info-bar">
          <span className="title">Video Views</span>
          <span className="view-count">
            {views.total} total, {views.distinct} unique
          </span>
        </div>
        <FeatureFlaggedComponent
          flag={GROW_ENGAGE_REMOVE_VIEWER_INFO_BARRIER}
          activationValue="show-if-invited"
        >
          {lockedDiv ? lockedDiv : views.total > 0 && viewers}
        </FeatureFlaggedComponent>
        <FeatureFlaggedComponent
          flag={GROW_ENGAGE_REMOVE_VIEWER_INFO_BARRIER}
          activationValue="show-viewers"
        >
          {views.total > 0 && viewers}
        </FeatureFlaggedComponent>
      </div>
    );
  }

  viewersRef = ref => {
    if (this.viewers) {
      this.viewers.removeEventListener('scroll', this.handleScroll);
    }

    this.viewers = ref;

    if (!this.viewers) {
      return;
    }

    this.viewers.addEventListener('scroll', this.handleScroll);
  };

  handleScroll = event => {
    const { scrollWidth } = event.target;

    this.setState({ fadeLeft: scrollWidth - 56 });
  };
};

const mapStateToProps = state => {
  const { has_named_video_views: hasNamedVideoViews } = state.user.current;
  const { views } = state.share_video.video || {};
  const { in_trim_mode: trimMode } = state.trimming;

  return {
    hasNamedVideoViews,
    views,
    trimMode,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleSlackInviteModal: () =>
      dispatch(
        toggleSlackInviteModal(true, INVITE_MODAL_SOURCE_VIEWER_LIST_PANE)
      ),
    toggleGoogleInviteModal: () =>
      dispatch(
        toggleGoogleInviteModal(true, INVITE_MODAL_SOURCE_VIEWER_LIST_PANE)
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewerList);
